export enum MenuTypes {
  SIDE_MENU_TOGGLE = "SIDE_MENU_TOGGLE",
  SIDE_MENU_SHOW = "SIDE_MENU_SHOW",
  SIDE_MENU_HIDDEN = "SIDE_MENU_HIDDEN",
  ADD_MENU_ITEMS = "ADD_MENU_ITEMS",
}